import { Autocomplete as MuiAutocomplete } from "@mui/material";
import styled from "@mui/material/styles/styled";

const Autocomplete = styled(MuiAutocomplete)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

Autocomplete.defaultProps = {
  disablePortal: true,
  fullWidth: true,
  margin: "dense",
  size: "small",
};

export default Autocomplete;
